import { BaseResource } from "./base.resource";

export const RegulatoryStatusAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class RegulatoryStatus extends BaseResource {
  active: boolean;
  status: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & RegulatoryStatusAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & RegulatoryStatusAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & RegulatoryStatusAccessLevel.Delete) > 0;
  }
}
